import { type FunctionComponent } from "react";

import { SmsOptInStatus } from "commonComponents/entity/cellPhone/CellPhoneInput/CellPhoneInput.types";
import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

interface ICellPhoneOptInStatusTagProps {
    smsOptInStatus: SmsOptInStatus;
    useBds?: boolean;
}

export const CellPhoneOptInStatusTag: FunctionComponent<ICellPhoneOptInStatusTagProps> = ({
    smsOptInStatus,
    useBds,
}) => {
    let statusType: StatusTypes = "";
    let statusText: string = "";

    switch (smsOptInStatus) {
        case SmsOptInStatus.None:
            return <></>;
        case SmsOptInStatus.OptedIn:
            statusType = "success";
            statusText = "Opted in";
            break;
        case SmsOptInStatus.RequestedOptIn:
            statusType = "pending";
            statusText = "Verification pending";
            break;
        case SmsOptInStatus.RequestedOptOut:
            statusType = "pending";
            statusText = "Opt out pending";
            break;
        case SmsOptInStatus.OptedOut:
            statusType = "";
            statusText = "Opted out";
            break;
        default:
            return <></>;
    }
    return <StatusTagDisplay statusType={statusType} statusText={statusText} useBds={useBds} />;
};
